var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCrownSimple = function SvgIconCrownSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.112 3.037a1.75 1.75 0 0 1 2.42.66l2.644 4.767 4.54-2.018.003-.002a1.75 1.75 0 0 1 2.407 2.01v.003L20.733 18.61a1.76 1.76 0 0 1-2.172 1.282l-.004-.001a24.6 24.6 0 0 0-13.125 0l-.004.001a1.76 1.76 0 0 1-2.172-1.282l-.002-.008-2.38-10.15A1.75 1.75 0 0 1 3.28 6.444l.004.002 4.54 2.018 2.644-4.767a1.75 1.75 0 0 1 .643-.66M12 5.06 9.456 9.646a1.76 1.76 0 0 1-2.237.738l-.003-.001-4.281-1.904 2.209 9.419a26.6 26.6 0 0 1 13.704 0l2.218-9.419-4.281 1.904-.004.001a1.76 1.76 0 0 1-2.237-.738l-.006-.01z",
    clipRule: "evenodd"
  })));
};
export default SvgIconCrownSimple;